import { BaseModel } from './BaseModel';
import AdditionalCriterion from './AdditionalCriterion';
import LearningOutcome from './LearningOutcome';
import Vimeo from './Vimeo';
import Learner from './Learner';
import LearningUnit from './LearningUnit';
import AssessmentStatus from './AssessmentStatus';
import PostMark from './PostMark';
import Meeting from './Meeting';
import PostSchedule from './PostSchedule';
import Criteria from './Criteria';
import BunnyVideo from './BunnyVideo';

export class Post extends BaseModel {
  static get entity() {
    return 'posts';
  }

  static get fk() {
    return 'post_id';
  }

  static get POST_TYPE() {
    return {
      LEARNING: 'Learning',
      MEETING: 'Meeting',
      FORMATIVE_ASSESSMENT: 'Formative Assessment',
      EVALUATION_ASSESSMENT: 'Evaluation Assessment'
    };
  }

  static get PART() {
    return {
      OVERVIEW: 'Overview',
      WORK_EXAMPLE: 'Work Example',
      REFLECTION: 'Reflection'
    };
  }

  static get PART_ORDER() {
    return {
      OVERVIEW: 1,
      WORK_EXAMPLE: 2,
      REFLECTION: 3
    };
  }

  static get PART_LIMIT() {
    return {
      OVERVIEW: 1,
      REFLECTION: 1
    };
  }

  static fields() {
    return {
      id: this.uid(),
      title: this.attr(null),
      description: this.attr(null),
      additional_criterion: this.hasMany(AdditionalCriterion, 'post_id'),
      vimeo_id: this.attr(null),
      vimeo: this.belongsTo(Vimeo, 'vimeo_id'),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      learning_unit_id: this.attr(null),
      learning_outcome_id: this.attr(null),
      learning_outcome: this.belongsTo(LearningOutcome, 'learning_outcome_id'),
      evaluate_learning_outcome: this.attr(null),
      images: this.attr(null),
      attachments: this.attr(null),
      thumbnail: this.attr(null),
      order: this.attr(null),
      assessment_statuses: this.hasMany(AssessmentStatus, 'post_id'),
      post_responses: this.attr(null),
      is_marked: this.boolean(false),
      is_submission: this.boolean(false),
      is_published: this.boolean(false),
      post_marks: this.hasMany(PostMark, 'post_id'),
      meeting: this.hasOne(Meeting, 'post_id'),
      post_schedules: this.hasMany(PostSchedule, 'post_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      published_at: this.attr(null),
      criterion_ids: this.attr([]),
      criteria: this.hasManyBy(Criteria, 'criterion_ids'),
      post_type: this.attr(null),
      part: this.attr(null),
      word_limit: this.attr(null),
      bunny_video_id: this.attr(null),
      bunny_video: this.hasOne(BunnyVideo, 'post_id')
    };
  }

  static apiConfig = {
    actions: {
      // fetchPostsByLearningUnitId(
      //   learning_unit_id,
      //   start = 0,
      //   limit = 15,
      //   sort = "order:ASC",
      //   options = {}
      // ) {
      //   return this.get(`/posts?learning_unit.id=${learning_unit_id}`, {
      //     params: {
      //       _start: start,
      //       _limit: limit,
      //       _sort: sort,
      //       ...options,
      //     },
      //   });
      // },

      // fetchPostLearner(
      //   user_id,
      //   learning_unit_id,
      //   start = 0,
      //   limit = 15,
      //   sort = "order:ASC"
      // ) {
      //   return this.get(`/learner/${user_id}/posts`, {
      //     params: {
      //       "learning_unit.id": learning_unit_id,
      //       _start: start,
      //       _limit: limit,
      //       _sort: sort,
      //     },
      //   });
      // },

      fetchOnePostLearner(user_id, post_id) {
        return this.get(`/learner/${user_id}/posts/${post_id}`);
      },

      // countPostsByLearningUnitId(learning_unit_id) {
      //   return this.get(`/posts/count?learning_unit.id=${learning_unit_id}`);
      // },

      fetchById(id) {
        return this.get(`/posts/${id}`);
      },

      /**
       * fetch evaluation assessment post
       * @typedef {Object} FetchEvaluationAssessmentParams
       * @property {Number | String} learningUnitId
       *
       * @param {FetchEvaluationAssessmentParams} params - request parameters
       */
      fetchEvaluationAssessments({ learningUnitId } = {}) {
        const params = {};

        if (learningUnitId) {
          params.learningUnitId = learningUnitId;
        }

        return this.get(`/posts/evaluation-assessments`, { params });
      },

      updatePost(id, body) {
        return this.put(`/posts/${id}`, body);
      },

      // updateOrder(body) {
      //   return this.post(`/posts/updateOrder`, body);
      // },

      createPost(body) {
        return this.post(`/posts`, body);
      },

      createPostEvaluationAssessments(body) {
        return this.post(`/posts/evaluation-assessments`, body);
      },

      updatePostEvaluationAssessments(id, body) {
        return this.put(`/posts/evaluation-assessments/${id}`, body);
      },

      deletePost(id) {
        return this.delete(`/posts/${id}`, {
          delete: id
        });
      },

      async fetchStatusInSection(postId, sectionId) {
        const promise = await this.get(`/posts/${postId}/sections/${sectionId}/statuses`, {
          save: false
        });

        if (promise?.response?.data) {
          const { data = [] } = promise.response;

          data.forEach(({ user, assessmentStatus = null } = {}) => {
            Learner.insert({
              data: [user]
            });

            if (assessmentStatus) {
              AssessmentStatus.insert({
                data: [assessmentStatus]
              });
            }
          });
        }

        return promise;
      }
    }
  };
}

export default Post;
